<template>
<div class="">
    <header-alt :overlay="true" :hideLogo="true" :hideNavigation="true"></header-alt>

    <price-prediction
        client="uusmaa"
    />
</div>
</template>

<script>
import { mapGetters } from "vuex";
import PricePrediction from '@/components/pricing/PricePrediction.vue'
export default {
  name: "ValuationUusmaa",
  components: {
      PricePrediction
  },
  validator: null,
  data() {
    return {
 
    };
  },
  created() {

  },
  watch: {

  },
  filters: {

  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pricing/ValuationUusmaa.vue